import { types } from '../constants';

export const fetchAllDocumentsDispatch = (documentType, branchId) => ({
  type: types.FETCH_ALL_DOCUMENTS,
  documentType,
  branchId
});

export const fetchAllDocumentsForBranchDispatch = (branchId) => ({
  type: types.FETCH_ALL_DOCUMENTS_FOR_BRANCH,
  branchId
});

export const openDocumentListDialogDispatch = (open) => ({
  type: types.OPEN_DOCUMENT_LIST_DIALOG,
  open
});

export const onDocumentFolderShowDispatch = (prefix) => ({
  type: types.DOCUMENT_SHOW_FOLDER_ITEMS,
  prefix
});

export const onDocumentListBackArrowDispatch = () => ({
  type: types.DOCUMENT_BACK_ARROW_CLICKED
});

export const onResetDocumentDispatch = () => ({
  type: types.DOCUMENT_RESET_ORIGINAL_STATE
});


export const onFullResetDocumentDispatch = () => ({
  type: types.FULL_RESET_DOCUMENTS
});

export const onDocumentSelectedForCourseDispatch = (documentLink) => ({
  type: types.DOCUMENT_SELECTED,
  documentLink
});


export const onFolderAddDispatch = (folderName) => ({
  type: types.FOLDER_ADDED,
  folderName
});

export const onAttachmentAddDispatch = (payload) => ({
  type: types.USER_ATTACHMENT_ADD,
  payload
});

export const onAttachmentRemovedDispatch = (payload) => ({
  type: types.USER_ATTACHMENT_REMOVE,
  payload
});
